import 'whatwg-fetch/dist/fetch.umd.js';
import 'promise-polyfill/dist/polyfill';

export default function submitForm(url, body, method = 'POST', grade = 0) {
  return fetch(
    url,
    {
      body,
      method,
      mode: 'cors',
      credentials: 'omit',
      redirect: 'follow'
    }
  ).then(response => {
    if (String(response.status).slice(0, 2) === '20') { // status 20x
      return Promise.resolve(response);
    } else {
      const error = new Error(`Error code ${response.status} from Leadform API`);
      error.response = response;
      return Promise.reject(error);
    }
  });
}
